/**
 * @generated SignedSource<<d4584bc27544222a018bbf6d8dd03bb8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SortDirection = "ASC" | "DESC" | "%future added value";
export type ProcessDefinitionFilterInput = {
  definitionId?: StringFilter | null | undefined;
  definitionKey?: StringFilter | null | undefined;
  definitionName?: StringFilter | null | undefined;
  definitionPriority?: IntFilter | null | undefined;
  definitionVersion?: StringFilter | null | undefined;
  id?: string | null | undefined;
  list?: StringFilter | null | undefined;
  siteUrl?: StringFilter | null | undefined;
  status?: EnumFilter | null | undefined;
};
export type StringFilter = {
  contains?: string | null | undefined;
  endsWith?: string | null | undefined;
  eq?: string | null | undefined;
  ignoreCase?: boolean | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  ne?: string | null | undefined;
  notIn?: ReadonlyArray<string> | null | undefined;
  startsWith?: string | null | undefined;
};
export type EnumFilter = {
  eq?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  ne?: string | null | undefined;
  notIn?: ReadonlyArray<string> | null | undefined;
};
export type IntFilter = {
  eq?: number | null | undefined;
  gt?: number | null | undefined;
  gte?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  lt?: number | null | undefined;
  lte?: number | null | undefined;
  ne?: number | null | undefined;
  notIn?: ReadonlyArray<number> | null | undefined;
};
export type ActiveProcessListsProviderQuery$variables = {
  filter?: ProcessDefinitionFilterInput | null | undefined;
  pageNum?: number | null | undefined;
  pageSize?: number | null | undefined;
  search?: string | null | undefined;
  searchBy?: ReadonlyArray<string | null | undefined> | null | undefined;
  sortBy?: string | null | undefined;
  sortDir?: SortDirection | null | undefined;
};
export type ActiveProcessListsProviderQuery$data = {
  readonly getProcessDefinitions: {
    readonly content: ReadonlyArray<{
      readonly definitionKey: string;
      readonly definitionName: string;
      readonly id: string;
    }>;
  };
};
export type ActiveProcessListsProviderQuery = {
  response: ActiveProcessListsProviderQuery$data;
  variables: ActiveProcessListsProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageNum"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageSize"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchBy"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortBy"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortDir"
},
v7 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filterInput",
        "variableName": "filter"
      },
      {
        "kind": "Variable",
        "name": "pageNum",
        "variableName": "pageNum"
      },
      {
        "kind": "Variable",
        "name": "pageSize",
        "variableName": "pageSize"
      },
      {
        "kind": "Variable",
        "name": "search",
        "variableName": "search"
      },
      {
        "kind": "Variable",
        "name": "searchBy",
        "variableName": "searchBy"
      },
      {
        "kind": "Variable",
        "name": "sortBy",
        "variableName": "sortBy"
      },
      {
        "kind": "Variable",
        "name": "sortDir",
        "variableName": "sortDir"
      }
    ],
    "concreteType": "ProcessDefinitionPage",
    "kind": "LinkedField",
    "name": "getProcessDefinitions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProcessDefinition",
        "kind": "LinkedField",
        "name": "content",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "definitionKey",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "definitionName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ActiveProcessListsProviderQuery",
    "selections": (v7/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ActiveProcessListsProviderQuery",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "821fbf8c8bb33af65db7bef0fe76020c",
    "id": null,
    "metadata": {},
    "name": "ActiveProcessListsProviderQuery",
    "operationKind": "query",
    "text": "query ActiveProcessListsProviderQuery(\n  $pageNum: Int\n  $pageSize: Int\n  $sortBy: String\n  $sortDir: SortDirection\n  $search: String\n  $searchBy: [String]\n  $filter: ProcessDefinitionFilterInput\n) {\n  getProcessDefinitions(pageNum: $pageNum, pageSize: $pageSize, sortBy: $sortBy, sortDir: $sortDir, search: $search, searchBy: $searchBy, filterInput: $filter) {\n    content {\n      id\n      definitionKey\n      definitionName\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6255b996c9ba7886208351291051d926";

export default node;
